<mat-card>
  <mat-card-title>
    <h1>
      <span class="title">{{'admin.countries.upload' | translate}} </span>
      <span>Forms Data</span>
    </h1>
  </mat-card-title>
  <mat-card-content>
    <form [formGroup]="fileForm" (ngSubmit)="uploadFile()">
      <div class="form-container">
        <mat-form-field appearance="fill">
          <ngx-mat-file-input (change)="getExtension()" [formControl]="fileControl" [accept]="accept" [multiple]="false" [placeholder]="'File to upload'">
            <mat-icon ngxMatFileInputIcon>folder</mat-icon>
          </ngx-mat-file-input>
        </mat-form-field>
        <h3>Valid file types are: .xls, .xlsx.</h3>
        <div class="upload-button-container">
          <button [disabled]="fileForm.invalid || (fileExtension !== 'xls' && fileExtension !== 'xlsx')" mat-raised-button color="primary" type="submit">
            <span>Upload</span>
          </button>
        </div>
      </div>
    </form>
  </mat-card-content>
</mat-card>
